// The Rally Point's target coordinates, remembered per world (on this device) — so they're still there after sending a
// command and coming back, after switching to another city, and after reopening the app.
import { create } from "zustand";

const KEY = "valor-web:rally-target";
type Target = { x: string; y: string };

function load(): Record<string, Target> {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}") as Record<string, Target>;
  } catch {
    return {};
  }
}

interface RallyTargetState {
  byWorld: Record<string, Target>;
  set: (wid: number, t: Target) => void;
}

export const useRallyTarget = create<RallyTargetState>((set, get) => ({
  byWorld: load(),
  set: (wid, t) => {
    const next = { ...get().byWorld, [String(wid)]: t };
    set({ byWorld: next });
    try {
      localStorage.setItem(KEY, JSON.stringify(next));
    } catch {
      /* private mode: remembered for this visit */
    }
  },
}));
